/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import deviceFieldsetTemplate from './device-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.device', [])
    .directive('agDevice', Device)
    .name;

/*@ngInject*/
function Device() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            device: '=',
            deviceTypes: '=',
            theForm: '=',
            isAdd: '='
        },
        controller: DeviceController,
        controllerAs: 'vm',
        templateUrl: deviceFieldsetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function DeviceController($element, $log, $scope, $mdUtil, $filter, agTypes, types, toast, $translate, deviceService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.types = types;
    vm.deviceCredentials = null;

    vm.deviceConfigOptions = {
        useWrapMode: true,
        mode: 'json',
        advanced: {
            enableSnippets: true,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true
        }
    };

    vm.onDeviceIdCopied = onDeviceIdCopied;
    vm.onAccessTokenCopied = onAccessTokenCopied;
    vm.getNumber = getNumber;
    vm.isChannelAssigned = isChannelAssigned;
    vm.validateConfig = validateConfig;
    vm.handleDeviceNumberChange = handleDeviceNumberChange;
    vm.handleBatchNumberChange = handleBatchNumberChange;
    vm.currentDate = new Date();
    vm.tmpProd = null;
    vm.subsystemOldNaming = true;
    vm.isSubsystem = vm.device?.type === vm.agTypes.deviceType.gateway || vm.device?.type === vm.agTypes.deviceType.sms || vm.device?.type === vm.agTypes.deviceType.generic ||
        vm.device?.type === vm.agTypes.deviceType.relaySystem || vm.device?.type === vm.agTypes.deviceType.modbus;

    $scope.$watch('vm.device.name', function(newVal) {
        const subsystemNameParts = newVal?.split('-') ?? [];
        vm.subsystemOldNaming = subsystemNameParts.length < 4;
    });

    $scope.$watch('vm.device', function(newVal) {
        if (newVal) {
            if (vm.device.id && vm.device.id.id) {
                deviceService.getDeviceCredentials(vm.device.id.id).then(
                    function success(credentials) {
                        vm.deviceCredentials = credentials;
                    }
                );
            }
            if (vm.device.type === agTypes.deviceType.temperatureSensorLines ||
                vm.device.type === agTypes.deviceType.moistureSensorLines ||
                vm.device.type === agTypes.deviceType.co2SensorLines) {
                if (angular.isUndefined(vm.device.firstSensorOffset) || vm.device.firstSensorOffset == null) {
                    vm.device.firstSensorOffset = 0;
                }
            }
            if (vm.device.type === agTypes.deviceType.levelIndicator && vm.device.mode !== 'auto') {
                let measurePoints = angular.fromJson(vm.device.measurePoints);
                vm.device.levelPositionX = measurePoints[0].pos.posX;
                vm.device.levelPositionY = measurePoints[0].pos.posY;
                vm.device.levelPositionZ = measurePoints[0].pos.posZ;
            }
        }
    });

    let positionsCalculated = false;

    watchPositions();

    $scope.$watch('vm.tmpProd', function(newVal) {
        handleProductionDateChange(newVal);
    });

    function convertToDate(dateString) {
        // Ensure the input is valid and has the correct format
        if (!/^\d{6}$/.test(dateString)) {
            return null;
        }

        // Extract the day, month, and year parts from the string
        var day = parseInt(dateString.substring(0, 2), 10);
        var month = parseInt(dateString.substring(2, 4), 10) - 1; // Month is 0-indexed in JavaScript Date
        var year = parseInt(dateString.substring(4, 6), 10);

        // Adjust the year to a 4-digit format
        year += 2000;

        // Create and return the Date object
        return new Date(year, month, day);
    }

    function handleProductionDateChange(value) {
        let parts = vm?.device?.name?.split('-') ?? [];
        if (angular.isDefined(value) && value !== null) {
            const productionDateString = $filter('date')(value, 'ddMMyy');
            let parts = vm?.device?.name?.split('-') ?? [];
            if (parts.length > 1) {
                parts[1] = productionDateString;
            }

            vm.device.name = parts.join('-');
        } else {
            if (parts.length > 1 && angular.isDefined(parts[1])) {
                vm.tmpProd = convertToDate(parts[1]);
            }
        }
    }

    function handleBatchNumberChange(value) {
        let parts = vm?.device?.name?.split('-') ?? [];
        if (angular.isDefined(value)) {

            if (parts.length > 2) {
                const subParts = parts[2].split('_');

                if (subParts.length > 1) {
                    parts[2] = value + '_' + subParts[1];
                } else {
                    parts[2] = value
                }
            }

            vm.device.name = parts.join('-');
        } else {

            if (parts.length > 2) {
                const subParts = parts[2].split('_');

                if (subParts.length > 0) {
                    return subParts[0];
                }
            }

            return '';
        }
    }

    function handleDeviceNumberChange(value) {
        let parts = vm?.device?.name?.split('-') ?? [];
        if (angular.isDefined(value)) {

            if (parts.length > 3) {
                parts[3] = value;
            }

            vm.device.name = parts.join('-');
        } else {

            if (parts.length > 3) {
                return parts[3]
            }

            return '';
        }
    }

    function watchPositions() {
        $scope.positionsWatch = $scope.$watch('vm.device.positionX + vm.device.positionY + vm.device.positionZ', function() {
            if (positionsCalculated) {
                positionsCalculated = false;
                return;
            }
            if (vm.device && (vm.device.type === agTypes.deviceType.temperatureSensorLines ||
                vm.device.type === agTypes.deviceType.moistureSensorLines ||
                vm.device.type === agTypes.deviceType.co2SensorLines)) {
                let x =0, y=0, z=0;
                if (angular.isDefined(vm.device.positionX) && vm.device.positionX != null) {
                    x = vm.device.positionX;
                }
                if (angular.isDefined(vm.device.positionY) && vm.device.positionY != null) {
                    y = vm.device.positionY;
                }
                if (angular.isDefined(vm.device.positionZ) && vm.device.positionZ != null) {
                    z = vm.device.positionZ;
                }
                vm.height = z;
                vm.radius = round(Math.sqrt(x*x+y*y));
                let radians = Math.atan2(y,x);
                if (radians < 0) {
                    radians += 2 * Math.PI;
                }
                vm.angle = round(radians * 180 / Math.PI);
            }
        });
        $scope.levelPositionsWatch = $scope.$watchGroup(['vm.device.levelPositionX', 'vm.device.levelPositionY', 'vm.device.levelPositionZ'], function() {
            if (vm.device && vm.device.type === agTypes.deviceType.levelIndicator && vm.mode !== 'auto') {
                let measurePoints = [{
                    id: 1,
                    pos: {}
                }];
                measurePoints[0].pos.posX = vm.device.levelPositionX;
                measurePoints[0].pos.posY = vm.device.levelPositionY;
                measurePoints[0].pos.posZ = vm.device.levelPositionZ;
                vm.device.measurePoints = angular.toJson(measurePoints);
            }
        });
    }

    function round(value) {
        return parseFloat((value).toFixed(13));
    }

    $scope.calculatePositions = () => {
        if (vm.device && (vm.device.type === agTypes.deviceType.temperatureSensorLines ||
            vm.device.type === agTypes.deviceType.moistureSensorLines ||
            vm.device.type === agTypes.deviceType.co2SensorLines)) {
            let angle = 0;
            let radius = 0;
            if (angular.isDefined(vm.angle) && vm.angle != null) {
                angle = vm.angle;
            }
            if (angular.isDefined(vm.radius) && vm.radius != null) {
                radius = vm.radius;
            }
            if (angle >= 180) {
                angle -= 360;
            }
            let angleRads = (angle * Math.PI) / 180;
            vm.device.positionX = radius * Math.cos(angleRads);
            vm.device.positionY = radius * Math.sin(angleRads);
            positionsCalculated = true;
        }
    };

    function validateConfig(editorName) {
        if (vm.device.config && vm.device.config.length) {
            try {
                angular.fromJson(vm.device.config);
                vm.theForm[editorName].$setValidity('configJSON', true);
            } catch(e) {
                vm.theForm[editorName].$setValidity('configJSON', false);
            }
        } else {
            vm.device.config = "{}";
            vm.theForm[editorName].$setValidity('configJSON', true);
        }
    }

    function isChannelAssigned(channelIndex, aerationSystem) {
        for (var i = 0; i < vm.device.assignedSystemsInfo.length; i++) {
            if (vm.device.assignedSystemsInfo[i].assetId.id !== aerationSystem.assetId.id && vm.device.assignedSystemsInfo[i].channelIds) {
                if (vm.device.assignedSystemsInfo[i].channelIds.indexOf(channelIndex) !== -1) {
                    return true;
                }
            }
        }
        return false;
    }

    function getNumber(num) {
        return new Array(num);
    }

    function onDeviceIdCopied () {
        toast.showSuccess($translate.instant('device.idCopiedMessage'), 750, $element.parent(), 'bottom left');
    }

    function onAccessTokenCopied () {
        toast.showSuccess($translate.instant('device.accessTokenCopiedMessage'), 750, $element.parent(), 'bottom left');
    }

}
